import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from '../../Components/designConstants';
import {
  CpsInternalLogsResponse,
  INTERNAL_TIME_CONFIG,
  InternalTimeFieldKey,
  hoursToMinutes
} from './cps-utils';
import { TimeInput } from './TimeInput';

interface SurveyInternalTimeProps {
  internalTimeLogs: CpsInternalLogsResponse;
  onChange?: (key: InternalTimeFieldKey, value: number) => void;
  readOnly?: boolean;
}

const SurveyInternalTime = ({
  internalTimeLogs,
  onChange,
  readOnly = false
}: SurveyInternalTimeProps) => (
  <div className='cps-internal-time'>
    <h6 className='cps-internal-time-title'>Remaining Time</h6>
    {INTERNAL_TIME_CONFIG.map(({ label, key, tooltip }) => (
      <div key={key} className='cps-internal-time-row'>
        <OverlayTrigger
          placement={Placement.LEFT}
          overlay={
            <Tooltip id={`tooltip-${key}`}>
              <strong>{label}</strong>
              <br />
              {tooltip}
            </Tooltip>
          }
        >
          <span className='cps-internal-time-label'>{label}</span>
        </OverlayTrigger>
        <TimeInput
          value={readOnly ? hoursToMinutes(internalTimeLogs[key]) : internalTimeLogs[key]}
          onChange={readOnly ? undefined : val => onChange?.(key, val)}
          readOnly={readOnly}
        />
      </div>
    ))}
  </div>
);

export { SurveyInternalTime };
